import { mapGetters } from 'vuex';

export default {
  data() {
    return {
    };
  },
  computed: mapGetters([
    'userInfo'
  ]),
  created() {
  },
  methods: {
    pageSkip (url) {
      this.$router.push(url);
    }
  }
};
